import React from 'react';
import { GracePeriodSelector } from './GracePeriodSelector';
import styles from './GracePeriodSection.module.scss';

interface GracePeriodSectionProps {
    value: number;
    onChange: (value: number) => void;
    className?: string;
}

export const GracePeriodSection: React.FC<GracePeriodSectionProps> = ({ value, onChange, className }) => {
    return (
        <div className={`${styles.container} ${className || ''}`}>
            <div className={styles.label}>Grace Period</div>
            <GracePeriodSelector
                value={value}
                onChange={onChange}
            />
        </div>
    );
};
